import useInitialCountryLocale from '@skippay/core/hooks/useInitialCountryLocale';

import { LOGIN, LOGIN_EN, REGISTRATION, REGISTRATION_EN } from '../constants/routes';

const useAuthLinksByCountry = (): {
	registrationLink: string;
	loginLink: string;
} => {
	const { country } = useInitialCountryLocale();
	return country === 'CZ'
		? {
				registrationLink: REGISTRATION,
				loginLink: LOGIN,
			}
		: {
				registrationLink: REGISTRATION_EN,
				loginLink: LOGIN_EN,
			};
};

export default useAuthLinksByCountry;
